import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allProjectsData } from "../../redux/actions/allProjects";
import Projects from "./projects";

const ProjectsPage = () => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        dispatch(allProjectsData({ page: currentPage, per_page: 15 }));
    }, [dispatch, currentPage]);
    const available = useSelector(state => state.allProjectsData.available);
    const pagination = useSelector(state => state.allProjectsData.pagination);
    const availableLoading = useSelector(state => state.allProjectsData.loading);
    const serviced_zipcodes = useSelector(state => state.allProjectsData.serviced_zipcodes);
    const serviced_zipcodes_count = useSelector(state => state.allProjectsData.serviced_zipcodes_count);
    const fair_use = useSelector(state => state.allProjectsData.fair_use);
    
    const refetchProjects = () => {
        dispatch(allProjectsData({ page: currentPage, per_page: 15 }));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    
    return (
        <Projects
            availableData={available}
            pagination={pagination}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            availableLoading={availableLoading}
            serviced_zipcodes={serviced_zipcodes}
            serviced_zipcodes_count={serviced_zipcodes_count}
            fair_use={fair_use}
            onRefetch={refetchProjects}
        />
    );
}

export default ProjectsPage;
